import { Reveal } from "@/components/Reveal";

const STAGES_IMG = "https://images.unsplash.com/photo-1488630228244-bcdf33562a43?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwzfHxsaXZlJTIwb3JjaGVzdHJhJTIwY29uY2VydCUyMHN0YWdlfGVufDB8fHx8MTc5MTkxMzgzNnww&ixlib=rb-4.1.0&q=85";

const CITIES = ["Paris", "St. Petersburg", "St Tropez", "Dubai", "Punta Mita", "Milan", "Moscow", "London", "New York"];

export const WorldStages = () => (
    <section id="stages" data-testid="stages-section" className="relative py-24 md:py-32 overflow-hidden">
        <img src={STAGES_IMG} alt="Orchestra performing on a theatre stage" className="absolute inset-0 w-full h-full object-cover opacity-25 img-luxe" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#08080a] via-[#08080a]/70 to-[#08080a]" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-left">
            <Reveal>
                <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">World Stages</p>
                <h2 className="font-serif text-4xl sm:text-5xl tracking-tight font-light text-[#fafafa] max-w-3xl">
                    From Beverly Hills to the world&rsquo;s great stages.
                </h2>
                <p className="mt-6 text-base sm:text-lg text-[#a1a1aa] leading-relaxed max-w-2xl">
                    We travel the world — with vocalists who sing in many languages — for high-end weddings and events
                    overseas. Your destination wedding is our home turf.
                </p>
            </Reveal>
        </div>
        <div className="relative mt-16 border-y border-white/10 py-6 overflow-hidden" data-testid="cities-marquee">
            <div className="marquee-track flex whitespace-nowrap w-max">
                {[...CITIES, ...CITIES].map((city, i) => (
                    <span key={i} className="mx-8 font-serif text-2xl md:text-4xl font-light text-[#fafafa]/80 italic">
                        {city} <span className="text-[#d4af37] not-italic mx-4">&middot;</span>
                    </span>
                ))}
            </div>
        </div>
    </section>
);
